/**
 * User-visible Croatian copy. Use diacritics: ć č đ š ž.
 */
export const hr = {
  common: {
    save: "Spremi",
  },
  nav: {
    home: "Naslovna",
    profile: "Profil",
    login: "Prijava",
    reportBug: "Prijavi grešku",
  },
  article: {
    notFound: "Članak nije pronađen.",
    byline: "Redakcija",
    deleteArticle: "Obriši članak",
    deleteArticleDialogTitle: "Brisanje članka",
    deleteArticleDialogBody:
      "Jeste li sigurni da želite obrisati ovaj članak? Ova se radnja ne može poništiti.",
    articleDeleted: "Članak je obrisan.",
  },
  comments: {
    sectionTitle: "Komentari",
    placeholder: "Napišite komentar…",
    submit: "Komentiraj",
    loginPrompt: "Prijavite se za ostavljanje komentara.",
    empty: "Nema komentara. Budite prvi!",
    added: "Komentar je dodan.",
    updated: "Komentar je ažuriran.",
    deleted: "Komentar je obrisan.",
    fallbackUser: "Korisnik",
  },
  reactions: {
    loginRequired: "Prijavite se za reagiranje.",
    submitError: "Greška pri slanju reakcije. Pokušajte ponovno.",
  },
  home: {
    noArticlesTitle: "Još nema objavljenih članaka",
    noArticlesBody: "Članci će se automatski generirati uskoro.",
    latestOverline: "Najnovije vijesti",
  },
  category: {
    notFound: "Kategorija nije pronađena.",
    empty: "Nema članaka u ovoj kategoriji.",
    loadMore: "Učitaj više",
    loading: "Učitavanje…",
  },
  profile: {
    title: "Profil",
    emailLabel: "E-mail",
    usernameLabel: "Korisničko ime",
    createdLabel: "Profil kreiran",
    deleteProfile: "Obriši profil",
    deleteDialogTitle: "Brisanje profila",
    deleteDialogBody:
      "Jeste li sigurni da želite obrisati profil? Ova se radnja ne može poništiti.",
    cancel: "Odustani",
    confirmDelete: "Obriši",
    deleted: "Profil je obrisan.",
    usernameUpdated: "Korisničko ime je ažurirano.",
  },
  usernameSetup: {
    welcome: "Dobrodošli!",
    hint: "Odaberite korisničko ime (slova, brojevi i _)",
    placeholder: "korisnicko_ime",
    success: "Korisničko ime je postavljeno.",
    documentTitle: "Postavi korisničko ime",
  },
  notFound: {
    title: "Stranica nije pronađena",
    backHome: "Natrag na naslovnicu",
  },
  footer: {
    copyright: (year: number) => `© ${year} Pinehood Tech d.o.o.`,
    terms: "Uvjeti korištenja",
    privacy: "Pravila privatnosti",
  },
  errors: {
    usernameRules:
      "Korisničko ime mora imati 3–20 znakova (slova, brojevi, _).",
    network: "Nema veze s poslužiteljem. Provjerite internetsku vezu.",
    generic: "Došlo je do greške. Pokušajte ponovno.",
  },
  focus: {
    panelOverline: "U fokusu",
  },
} as const;
